import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "branding"
    }}>{`Branding`}</h1>
    <p>{`To ensure users know they are interacting with your plugin, include branding throughout the plugin experience. Below are some examples.`}</p>
    <ul>
      <li parentName="ul">{`Onboarding and branding`}</li>
      <li parentName="ul">{`Customized plugin UI`}</li>
    </ul>
    <h2 {...{
      "id": "onboarding-and-branding"
    }}>{`Onboarding and branding`}</h2>
    <h4 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h4>
    <p>{`When the user is interacting with the plugin for the first time for example in the onboarding or login screen, including the plugin logo will help the user identify the plugin in the future. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/5530d/Branding-1.webp 320w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/0c8fb/Branding-1.webp 640w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/94b1e/Branding-1.webp 1280w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/0b34d/Branding-1.webp 1920w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/9acb0/Branding-1.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/dd4a7/Branding-1.png 320w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/0f09e/Branding-1.png 640w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/bbbf7/Branding-1.png 1280w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/ac7a9/Branding-1.png 1920w", "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/369c0/Branding-1.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/bbbf7/Branding-1.png",
            "alt": "Panel branding example",
            "title": "Panel branding example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/5530d/Branding-2.webp 320w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/0c8fb/Branding-2.webp 640w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/94b1e/Branding-2.webp 1280w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/0b34d/Branding-2.webp 1920w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/9acb0/Branding-2.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/dd4a7/Branding-2.png 320w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/0f09e/Branding-2.png 640w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/bbbf7/Branding-2.png 1280w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/ac7a9/Branding-2.png 1920w", "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/369c0/Branding-2.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/9f22d2fe32e3e18a3ec6f5a3404d1292/bbbf7/Branding-2.png",
            "alt": "modal branding example",
            "title": "modal branding example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "customized-plugin-ui"
    }}>{`Customized plugin UI`}</h2>
    <h4 {...{
      "id": "best-practices-1"
    }}>{`Best practices`}</h4>
    <p>{`Customizing the UI to include brand colors, will help users distinguish your plugin's interface. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/5530d/Branding-3.webp 320w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/0c8fb/Branding-3.webp 640w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/94b1e/Branding-3.webp 1280w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/0b34d/Branding-3.webp 1920w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/9acb0/Branding-3.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/dd4a7/Branding-3.png 320w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/0f09e/Branding-3.png 640w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/bbbf7/Branding-3.png 1280w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/ac7a9/Branding-3.png 1920w", "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/369c0/Branding-3.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/e9f4f2073112a02bf63c0dd93eac1e98/bbbf7/Branding-3.png",
            "alt": "Panel customization example",
            "title": "Panel customization example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/5530d/Branding-4.webp 320w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/0c8fb/Branding-4.webp 640w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/94b1e/Branding-4.webp 1280w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/0b34d/Branding-4.webp 1920w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/9acb0/Branding-4.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/dd4a7/Branding-4.png 320w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/0f09e/Branding-4.png 640w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/bbbf7/Branding-4.png 1280w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/ac7a9/Branding-4.png 1920w", "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/369c0/Branding-4.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/0071e53f43ddc58604ab87f4e978a88b/bbbf7/Branding-4.png",
            "alt": "Modal customization example",
            "title": "Modal customization example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      